import React, { Component } from "react"
import { Card, CardBody} from 'mdbreact';

import FormField from "../Components/FormField"
import Paginator from "../Components/Paginator"
import Paystack from "../Components/Payments"

import "./Messaging.css"

export default class Messaging extends Component {
    constructor(props){
        super(props)        

        let sortOptions = ["Name", "Type", "Ranking"]
        sortOptions = sortOptions.map((item, index) => {
            return { label : item, value : item.toLowerCase() }
        })

        let vendorTypes = ["alaga","asoebi","asoebibella","attire","bead","beautiful","bridal dress","bridal gown","bridal stylist",
                       "brides outfit","brides robe","brides shoes","bridesmaid dresses","bridesmaids","bridesmaids hair","bridesmaids makeup",
                       "caterer","cinematographer","clutch","cocktails","coordination","coordinator","couple","creative director","decorator",
                       "design brand","dessert","desserts","dress designer","drinks","earrings","eru iyawo","fascinator","fashion illustrator",
                       "florals","florist","flowers","food","gown","grooms outfit","grooms shoes","grooms suit","grooms tuxedo","groomsmen suit",
                       "groomtobe","hair piece","hairstylist","headpiece","henna","hotel","ig","instagram","jewellery","kente","lashes","live band",
                       "lovely","makeup","mc","model","models","muse","music","nails","outfits","photographer","photobooth","planners","ring","robe","see",
                       "shoes","special effect","spotted","stationery","studio","suit","suits","thank you","tiara","to","turban","us","venue",
                       "wedding coordinator","wedding dress"]
        vendorTypes = vendorTypes.map((item, index) => {        
            return { 
                    label : item.replace(/\w\S*/g, function(txt){
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                        }), 
                    value : item
                }
        })

        this.state = {            
            data : {
                vendorTypesToInvite : []
            },
            data_status : {

            },
            vendorTypes : vendorTypes,
            itemsPerPage : 100,
            vendors : [],
            vendorStore : [],
            vendorTypesToInvite : [],
            currentTab : 0,
            showTabs : true,
            sortOptions : sortOptions,
            showVendorOptions : false,
            showInviteByType : false,
            vendorPage : 1      
        }

        
    }

    componentDidMount(){
        this.getVendors("&page=1&pageSize=50")              
    }

    sortVendors = (key) => {
        this.state.vendors.sort((a, b) => {            
            switch(key){
                case "name":
                    a = a.id
                    b = b.id
                    return a === b ? 0 : a < b ? -1 : 1
                case "type":
                    const vendorType = this.state.data.vendorType || ""                    
                    a = a.types.includes(vendorType.toLowerCase())
                    b = b.types.includes(vendorType.toLowerCase())
                    return a === b ? 0 : a ? -1 : 1
                case "ranking":
                    a = a.likes
                    b = b.likes
                    return a === b ? 0 : a < b ? 1 : -1
                default:
                    return [];
            }
        })
    } 

    filterVendorsByType = (vendorTypes) => {
        var result = this.state.vendors.filter((vendor, index) => {
            return vendor.types.some((type) => {
                type = type.toLowerCase()
                return vendorTypes.includes(type)
            })
        })

        return result
    }

    getVendors = (extraQueries) => {
        this.setState({
          loadingVendors: true
        })

        extraQueries = extraQueries || "&page=1&pageSize=50"
        console.log(extraQueries)
        var url = 'https://api.lushplans.com/_allvendors?wp=hardcodedplaintext' + extraQueries
        // var url = 'https://127.0.0.1/_allvendors?wp=hardcodedplaintext'
        // var url = 'https://raw.githubusercontent.com/uchibeke/lushplans-backend/master/libs/processedVendors.json?token=AZbPir0MH07jObsNwMBllIaHkKeN_quxks5bDZYhwA%3D%3D'

        fetch(url)
        .then(response => {
          if (!response.ok) {
            throw Error("Network request failed")
          }
          return response
        })
        .then(d => d.json())
        .then(d => {
            console.log(d)
            this.setState({
                totalPages : d.totalPages,
                loadingVendors : false
            })

            const data = d.data
            let vendors = data.filter((item, index) => {
                return index <= 49                         
            })
            
            let vendorsArray = []
            let chunk = this.state.itemsPerPage
            
            for (let index = 0; index < vendors.length; index +=chunk) {
                vendorsArray = vendorsArray.concat(vendors.slice(index ,index+chunk))
            }

            this.setState({ vendors : vendorsArray })                        
        },() => {
          this.setState({
            requestFailed: true
          })
        }).catch((err) => {
            this.setState({ 
                loadingVendors : false
            })
        })
    
    }

    changeSortParam = (data, isValid) => {
        this.saveToState(data, isValid)

        let sortKey = data.value
        if(data.name === "vendorType"){
            sortKey = "type"
        }
        this.sortVendors(sortKey)

        console.log(data)
        this.setState({
            showVendorOptions : data.value === "type" || data.name === "vendorType"
        })
        
    }

    saveToState = (data, isValid) => {        
        const { name, value } = data
        
        const newData = Object.assign(this.state.data, {[name]: value})  
        
        this.setState({ 
          data : newData,
          data_status : Object.assign(this.state.data_status, {[name] : isValid})
        });
    
    }

    onClickPageButton = (e) => {        
        test.persist()        
        this.setState({
            currentTab : Number(e.target.firstChild.nodeValue) - 1    
        }, () => {
            window.scrollTo(0,0)
        })
        
    }

    
    renderPageButtons= () => {
        let buttons = []        
        for(let i = 0; i < this.state.vendors.length; i++){   
            //  TODO : ADD STYLING
            let extraClasses = " "                        
            if (this.state.page === (i + 1)){            
                extraClasses += "activePaginatorButton"
            }    
            const classes = "paginatorButton rounded-circle" + extraClasses 
            buttons.push(
            <button key={i} className={classes} onClick={this.onClickPageButton}>
                {i + 1}
            </button>
            )

        }        
        return buttons
    }

    printSelected = () => {
        const keys = Object.keys(this.state.data)
        let selected = keys.filter((item, index) => {
            return this.state.data[item]
        })    

        const index = selected.indexOf("vendorTypesToInvite")
        if (index > -1) {
            selected.splice(index, 1);
        }
        this.sendSelectedVendors(selected)                   
    }    

    inviteVendorsByType = () => {
        const types = this.state.data.vendorTypesToInvite
        this.sendSelectedVendors(this.filterVendorsByType(types))
    }

    sendSelectedVendors = (vendors) => {
        const data = {
            vendorIDs : vendors
        }
                                              
        fetch("/_message-selected", {
            method: 'POST',
            headers: new Headers({
                       'Accept': 'application/json',
                       'Content-Type': 'application/json',
              }),
            body: JSON.stringify(data)
          })
          .then((response) => {
              console.log(response)
          })
    }

    renderPage = (vendors) => {
        console.log("VENDORS ", vendors)
        return (
        <div className="row">
            {vendors.map((item, id) => {                                
                return <VendorCard 
                        {...item}
                        key={id}
                        onClick={()=>{this.saveToState({ name : item.id, value : !(this.state.data[item.id] || false)})}}
                        onInput={(e)=>{this.saveToState({ name : item.id, value : e.target.checked})}}
                        checked={this.state.data[item.id]}
                        />
            })}
        </div>
        )
    }

    onPageChange = (page) => {  
        this.setState({
            vendorPage : page
        }, () => {
            console.log("Incoming page : ", page)      
            var queryString = "&page=" + page + "&pageSize=50"
            this.getVendors(queryString)
        })        
    }

    render(){
        if(!this.state.showInviteByType){
            return(
                <div className="height mt-4">
                    <Paystack 
                        text="Testing"
                        callback={()=>{}}
                        close={()=>{}}
                        reference="1234"
                        email="res@gmail.com"
                        amount={12345}
                    />
                    <hr className="spacer"></hr>
                    <button onClick={()=>{this.setState({
                    showInviteByType : true
                    })}}
                    className="btn btn-primary btn-sm">
                        Toggle Invite By Type 
                    </button>
                    <div>
                        <FormField
                            field={{
                                name : "sortParam",
                                label : "SORT BY : ",
                                type : "select",
                                container_css : "mb-4",
                                meta : {
                                    options : this.state.sortOptions
                                }

                            }}
                            value={this.state.data.sortParam || ""}
                            fieldChange={this.changeSortParam}
                        />
                        <div hidden={!this.state.showVendorOptions}>
                        <FormField
                            field={{
                                name : "vendorType",
                                label : "VENDOR TYPE : ",
                                type : "select",
                                container_css : "mb-4",
                                meta : {
                                    options : this.state.vendorTypes
                                }

                            }}
                            value={this.state.data.vendorType || ""}
                            fieldChange={this.changeSortParam}
                        />
                        </div>
                    </div>                
                                        
                    <Paginator 
                    renderPage={this.renderPage}
                    items={this.state.vendors}
                    page={this.state.vendorPage}
                    totalPages={this.state.totalPages}     
                    onPageChange={this.onPageChange}
                    loading={this.state.loadingVendors}            
                    />

                    {/* {this.renderPageButtons()} */}

                    <button onClick={this.printSelected}
                    className="btn btn-primary btn-sm">
                    Invite Selected
                    </button>
                    <br></br>
                    <br></br>
                </div>
            )
        }
        else{
            return(
                <div className="height mt-4">
                    <hr className="spacer"></hr>

                    <button onClick={()=>{this.setState({
                        showInviteByType : false
                    })}}
                    className="btn btn-primary btn-sm">
                        Toggle Invite By Type 
                    </button>
                    <FormField
                        field={{
                            name : "vendorTypesToInvite",
                            label : "VENDOR TYPES : ",
                            type : "select",
                            container_css : "mb-4",
                            meta : {
                                options : this.state.vendorTypes,
                                multiple : true
                            }

                        }}
                        value={this.state.data.vendorTypesToInvite}
                        fieldChange={this.saveToState}
                            />
                    <button onClick={this.inviteVendorsByType}
                    className="btn btn-primary btn-sm">
                        Invite Vendors
                    </button>
                </div>
            )
        }
    }
}

const VendorCard = props => {      
    const classes = props.checked ? "inverse-card" : ""    
    return (
      <div className={"col-md-4 col-xs-12 col-sm-6 col-lg-3 col-center-block " + classes} onClick={props.onClick}>      
        <Card>
          <CardBody>
              <h5 className="pink-text"><i className="fa fa-trophy"> </i> {(props.types[0] || "").toUpperCase()}
                </h5>
                    <input
                    type="checkbox"
                    className="ml-2 inline-input pull-right vendor-cb"
                    onSelect={props.onInput}
                    onInput={props.onInput}
                    onClick={props.onInput}
                    onChange={props.onInput}
                    checked={props.checked}>        
                    </input>
              <div className="card-body">
                <h4 className="card-title text-center vendorName">
                  <strong>
                    {props.profile && props.profile.name ? props.profile.name : props.id.replace("@", "") }
                  </strong>
                </h4>
                <h6> <i className="fa fa-heart rating"></i>  
                  {"  "+props.likes.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} feels
                </h6>
                <h6> <i className="fa fa-edit rating"></i>  
                  {"  "+props.appearance.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} weddings
                </h6>
                <h6> <i className="fa fa-comments rating"> </i> 
                  {"  "+props.comments.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} taps
                </h6>
              </div>              
          </CardBody>
        </Card>
        <hr></hr>
      </div>
      )
}



// WEBPACK FOOTER //
// ./src/Messaging/Messaging.js